/* eslint-disable prefer-const, no-invalid-this, prefer-const */
/**
 * Run a function only once after 'wait' milliseconds. How to use: see unit tests
 * @param {Function} func Function to be used
 * @param {number} wait Time in ms to wait before running the function
 * @param immediate
 * @returns {Function}
 */
export function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this, args = arguments;
        const callNow = immediate && !timeout;
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            timeout = null;
            !immediate && func.apply(context, args);
        }, wait);

        callNow && func.apply(context, args);
    };
}

/**
 *
 *
 * @export
 * @param {any} html dom as string
 * @returns html dom object
 */
export function parseToDom(strData) {
    const parser = new window.DOMParser();
    return parser.parseFromString(strData, 'text/html');
}

/**
 * Run this function for scroll the window to top with smoothness.
 * @param {number} scrollPosition scroll position
 */
export function scrollToTop(scrollPosition = 0) {
    window.scroll({top: scrollPosition, behavior: 'auto' });
}

/**
 * Run this function to check whether value of the element is null/empty/undefined.
 * @param {any} elm attribute/object/class
 * @returns boolean
 */
export function isNullOrEmptyOrUndefined(elm) {
    if(elm === null || elm === '' || elm === undefined) {
        return false;
    }
    return true;

}

/**
 * @export sendDataToAnalytic
 * @param
 * @returns
 */
export function sendDataToAnalytic(...args) {
    const [fnname, analyticData] = args;
    if (typeof window[fnname] === 'function') {
        if (analyticData !== undefined) {
            window[fnname].apply(null, analyticData);
        } else {
            window[fnname].apply(null);
        }
    }
}


// WEBPACK FOOTER //
// /src/common/utils.js